var map = {
	"./tree_1_3.png": "6f34",
	"./tree_1_4.png": "54f3",
	"./tree_2_3.png": "0e70",
	"./tree_2_4.png": "e82a",
	"./tree_3_3.png": "796c",
	"./tree_3_4.png": "14de",
	"./tree_4_4.png": "91ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "30fa";